export function addStateToQuery(query: string | undefined, state: string): string {
  const stateFilter = state ? `state:${state}` : ''

  if (!query) return stateFilter

  const terms = query.split(' ')
  const existingStateIndex = terms.findIndex(term => term.startsWith('state:'))

  if (existingStateIndex !== -1) {
    if (stateFilter) {
      terms[existingStateIndex] = stateFilter
      return terms.filter((term, i) => i === existingStateIndex || !term.startsWith('state:')).join(' ')
    } else {
      return terms.filter(term => !term.startsWith('state:')).join(' ')
    }
  }

  if (!stateFilter) return query

  const before = terms.slice(0, 2)
  const after = terms.slice(2)
  return [...before, stateFilter, ...after].join(' ')
}

export function getStateFromQuery(query: string | undefined): string {
  if (!query) return ''

  const stateTerms = query.split(' ').filter(term => term.startsWith('state:'))
  if (stateTerms.length === 0) return ''

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  return stateTerms[0]!.substring('state:'.length)
}
